"use client";

import { Riple } from "react-loading-indicators";
import { useSelector } from "react-redux";

export default function FullLoading() {

	const fullLoading: boolean = useSelector(
		(state: any) => state.main.fullLoading
	);

	if (fullLoading) {
		return (
			<div className="w-full h-full fixed z-100 flex justify-center items-center bg-black/25 top-0 left-0">
				<Riple color={["#0589ba", "#07aeeb", "#2cc2f9", "#5ed0fa"]} />
			</div>
		);
	}
}
